import { Seo } from 'ui-components'
import { getSearchLink } from 'utils'
import { Main } from './Main'

const App = (props) => {
  const {} = props

  return (
    <>
      <Seo
        title='Mapstack Portal - Explore our community maps'
        description='Explore and discover publicly available maps of intriguing datasets on Mapstack. Find insights and visualize data from a variety of sources, all in one place.'
        canonical={getSearchLink()}
      />

      <Main />
    </>
  )
}

export { App }
export default App
